<template>
  <div class="modal-inline-backdrop modal-backdrop in"></div>
</template>

<script>
export default {
  name: 'modal-backdrop-inline',
}
</script>
